import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { buildBrandUrlWithCategory } from '../../../helpers/routes';
import Brand from '../styled/Brand';
import withCountryCode from '../../../components/RoutesHoc/RoutesHoc';

const mapStateToProps = ({ api: { designers, department } }) => ({
  designers,
  department,
});

// TODO: refactor in functional component
class BrandTitle extends Component {
  render() {
    const { linkId, brandUrl, brandName, fontSize, brandId, categoryId, buildUrlWithCountry } = this.props;
    const href = buildUrlWithCountry(buildBrandUrlWithCategory(brandUrl, brandId, categoryId));

    return (
      <Brand data-cy="title-product-brand" fontSize={fontSize}>
        {brandUrl && (
          <a id={linkId} href={href} data-cy="anchor-product-brand">
            {brandName}
          </a>
        )}
        {!brandUrl && brandName}
      </Brand>
    );
  }
}

BrandTitle.defaultProps = {
  brandUrl: null,
  linkId: 'brand-product-detail',
};

BrandTitle.propTypes = {
  brandName: PropTypes.string.isRequired,
  brandUrl: PropTypes.string,
  linkId: PropTypes.string,
  buildUrlWithCountry: PropTypes.func.isRequired,
  fontSize: PropTypes.string.isRequired,
};

BrandTitle = connect(mapStateToProps)(BrandTitle);
export default withCountryCode(BrandTitle);
